import {useState, useEffect} from 'react';
import ListaResponsiva from '../../../components/ListaResponsiva/Extracao';
import http from '../../../services/http';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import styles from './extracao.module.css';
import {alerta} from "../../../components/Alert";

const tHead = [
    'Nome da loteria',
    'Encerra',
    'Tipo',
    'Seg',
    'Ter',
    'Qua',
    'Qui',
    'Sex',
    'Sáb',
    'Dom',
    'Editar',
    'Status'
];

export default function Loterias(props) {
    const [listaJogos, setListaJogos] = useState([]);
    const [nomeFilter, setNomeFilter] = useState('');
    const [listaFiltrada, setListaFiltrada] = useState([]);
    const [loadingAtivo, setLoadingAtivo] = useState(true);

    const [carregaPost, setCarregaPost] = useState(false);


    useEffect(() => {
        const requestUsuarios = async () => {
            try {
                const response = await http.get('/loterias', {params: {todas: 1}});
                const {data} = response.data;

                setListaJogos(data);
                setLoadingAtivo(false);
            } catch (e) {
                setLoadingAtivo(false);
                alerta(e.response.data);
            }
        };
        requestUsuarios();
    }, []);

    const salvarEdicoes = async (data) => {
        try {

            setCarregaPost(true);
            const response = await http.put('/loterias/' + data.id, {
                nome: data.nome,
                hora: data.hora,
                domingo: data.domingo,
                segunda: data.segunda,
                terca: data.terca,
                quarta: data.quarta,
                quinta: data.quinta,
                sexta: data.sexta,
                sabado: data.sabado,
                quantidade_sorteios: data.quantidade_sorteios,
                abrir_dias_antes: data.abrir_dias_antes,
                ativo: !data.ativo,
                milhar_moto: data.milhar_moto
            });

            alerta(response.data);

            const novasLoterias = listaJogos.map(loteria => {
                if (loteria.id === data.id) return {...loteria, ativo: !loteria.ativo}

                return loteria;
            });

            setListaJogos(novasLoterias);

            setCarregaPost(false);
        } catch (e) {
            alerta(e.response.data);
            setCarregaPost(false);
        }
    };

    useEffect(() => {
        const funcaoQueFiltra = () => {
            return listaJogos.filter((usuario) => {
                return (
                    usuario.nome
                        .toLowerCase()
                        .indexOf(nomeFilter.toString().toLowerCase()) >= 0
                );
            });
        };
        const setFilter = () => {
            setListaFiltrada(funcaoQueFiltra());
        };

        setFilter();
    }, [nomeFilter, setListaFiltrada, listaJogos]);

    return (
        <>
            <div className="titulo-principal">Extrações</div>

            <div className="conteudo-principal d-flex duas-colunas">
                <input
                    onChange={(c) => setNomeFilter(c.target.value)}
                    type="text"
                    className="form-control"
                    placeholder="Filtrar por nome"
                />
                <button
                    type="button"
                    className={`btn btn-info ${styles.btnCriar}`}
                    onClick={() => props.history.push('/extracao/criar')}
                >
                    Nova Loteria
                </button>
            </div>

            {listaJogos.length > 0 && (
                <ListaResponsiva
                    tHead={tHead}
                    tBody={listaFiltrada}
                    tButton1={salvarEdicoes}
                    carregaPost={carregaPost}
                />
            )}

            {loadingAtivo && <div className="loader"/>}
        </>
    );
}
